import Ajax from "./ajax";
import { jsToFormData } from "@/utils/func";

// 首页
export const getMajor = data => Ajax.get(`/fs-user-index-pro`, data);
export const selectMajor = data => Ajax.get(`/fs-user-index-up-pro`, data);
export const getNewNotice = () => Ajax.get(`/fs-user-index-new-notice`, null);
export const getNewCourse = () => Ajax.get(`/fs-user-index-new-course`, null);
export const getStudyRate = () => Ajax.get(`/fs-user-index-rate`, null);
export const getNewExams = () => Ajax.get(`/fs-user-index-exam`, null);
export const getNewStudy = () => Ajax.get(`/fs-user-index-last-learn`, null);
export const getNewPractice = () => Ajax.get(`/fs-user-index-last-pra`, null);

// 个人中心
export const getUserInfo = () => Ajax.get(`/fs-user-index-info`, null);
export const updateUserInfo = data => Ajax.post(`/fs-user-up-info`, jsToFormData(data));
export const upMailingAddress = data => Ajax.post(`/fs-up-mailing-address`, jsToFormData(data));
export const confirmStatus = data => Ajax.post(`/fs-confirm-status`, jsToFormData(data));
export const updateMobile = data => Ajax.post(`/fs-user-set-mobile`, jsToFormData(data));
export const getStudentInfo = data => Ajax.get(`/fs-user-my-info`, data);
export const getClassInfo = data => Ajax.get(`/fs-user-my-class`, data);
export const getClassMoney = data => Ajax.get(`/fs-user-my-class-money`, data);
export const addClassMoney = data => Ajax.post(`/fs-user-post-money`, jsToFormData(data));
export const myTkScore = () => Ajax.get(`/fs-user-get-unify`, null);
export const myRDScore = () => Ajax.get(`/fs-user-get-recognize`, null);
export const myStudentScore = () => Ajax.get(`/fs-new-score`, null);
export const examReview = data => Ajax.post(`/fs-user-exam-review`, jsToFormData(data));
export const courseReview = data => Ajax.post(`/fs-user-course-review`, jsToFormData(data));
export const mailboxApi = data => Ajax.get(`/fs-mailbox`, data);
export const mailboxApplyApi = data => Ajax.post(`/fs-mailbox-apply`, jsToFormData(data));
export const getTimetableApi = data => Ajax.get(`/fs-get-timetable`, data);
export const courseLiveUrl = data => Ajax.get(`/fs-course-live-url`, data);  //获取直播地址
export const getAllCourseApi = data => Ajax.get(`/fs-get-all-course`, data);
export const getStartYear = data => Ajax.get(`/fs-start-year`, data);  //获取课表学年
// 前置学历
export const userPreReview = data => Ajax.get(`/fs-user-pre-review`, data);  //获取前置学历复查
export const upMeansPhoto = data => Ajax.post(`/fs-up-means_photo`, jsToFormData(data));  //上传资料照片
// 毕业照
export const adultStudentUserGradPhoto = data => Ajax.get(`/v1-adult-student-user-grad-photo`, data);  //获取最新毕业照详情
export const adultStudentUpGradPhoto = data => Ajax.post(`/v1-adult-student-up-grad-photo`, jsToFormData(data));  //上传毕业照片
// 基础信息修改
export const adultStudentUserModify = data => Ajax.get(`/v1-adult-student-user-modify`, data);  //获取基础信息修改申请记录
export const adultStudentUserModifyUp = data => Ajax.post(`/v1-adult-student-user-modify-up`, jsToFormData(data));  //上传申请资料
// 联系方式修改
export const getUserSendCode = (data) => Ajax.post(`/fs-user-send-sms`, jsToFormData(data), false);//获取验证码
//更新学生手写签名-成教
export const adultStudentUpSignImg = (data) => Ajax.post(`/v1-adult-student-up-sign-img`, jsToFormData(data), false);

// 学习中心
export const getMyCourse = data => Ajax.get(`/fs-user-my-course?course_type=${data.course_type}&rate_type=${data.rate_type}`, null);
export const getMyCourseAE = data => Ajax.get(`/fs-user-my-course?rate_type=${data.rate_type}`, null);
export const getCourseType = () => Ajax.get(`/fs-user-my-course-type`, null);
export const getCourseDetails = data => Ajax.get(`/fs-user-my-course-info`, data);
export const getWorkPercent = data => Ajax.get(`/fs-user-section-task`, data);
export const getSections = data => Ajax.get(`/fs-user-section`, data);
export const getSectionDetail = data => Ajax.get(`/fs-user-section-learn?course_id=${data.course_id}&section_id=${data.section_id}`, null);
export const getMyNotes = data => Ajax.get(`/fs-user-note-my`, data);
export const addNotes = data => Ajax.post(`/fs-user-note-post`, jsToFormData(data));
export const deleteMyNote = data => Ajax.post(`/fs-user-note-delete`, jsToFormData(data));
export const updateIsPublic = data => Ajax.post(`/fs-user-note-up-open`, jsToFormData(data));
export const getNotes = data => Ajax.get(`/fs-user-note-all`, data);
export const selectQuestionAnswers = data => Ajax.get(`/fs-user-aq-get`, data);
export const addQuestionAnswer = data => Ajax.post(`/fs-user-aq-post`, jsToFormData(data));
export const getMajorPlan = () => Ajax.get(`/fs-user-my-course-plan`, null);
export const getMaterial = () => Ajax.get(`/fs-user-my-course-material`, null);
export const videoRecord = data => Ajax.post(`/fs-user-rate_record`, jsToFormData(data));

// 章节作业/练习
export const getWorkList = data => Ajax.get(`/fs-user-task-list`, data);
export const getHomeWork = data => Ajax.get(`/fs-user-question-sec-work`, data);
export const saveAnswer = data => Ajax.post(`/fs-user-question-post-answer`, jsToFormData(data, false), false);
export const saveAnswerErr = data => Ajax.post(`/fs-user-error-post-make`, jsToFormData(data, false), false);
export const postAnswer = data => Ajax.post(`/fs-user-post-submit`, jsToFormData(data, false));
export const getPracticeList = data => Ajax.get(`/fs-user-practice`, data);
export const getPractice = data => Ajax.get(`/fs-user-question-sec-pra`, data);
export const getAnalysis = data => Ajax.get(`/fs-user-question-make-info`, data);
export const saveCollect = data => Ajax.post(`/fs-user-coll-post`, jsToFormData(data), false);
export const delCollect = data => Ajax.post(`/fs-user-coll-del`, jsToFormData(data), false);
export const addTopicNote = data => Ajax.post(`/fs-user-qnote-post`, jsToFormData(data));
export const postCorrect = data => Ajax.post(`/fs-user-post-feed`, jsToFormData(data));
export const getPaperApi = data => Ajax.get(`/fs-paper`, data);
export const getPaperVtpApi = data => Ajax.get(`/fs-paper-vtp`, data);
export const getPaperUpApi = data => Ajax.post(`/fs-paper-up`, jsToFormData(data));
export const getDpsApi = data => Ajax.get(`/fs-dps`, data);
export const getDpsDriApi = data => Ajax.get(`/fs-dps-dri`, data);
export const postDpsSubmitSubDrApi = data => Ajax.post(`/fs-dps-submit-sub-dr`, jsToFormData(data));
export const getDegreeDaApi = data => Ajax.get(`/fs-degree-da`, data);
export const postDegreeDaApi = data => Ajax.post(`/fs-degree-da-post`, jsToFormData(data));


// 智能练习
export const getTypeSmart = data => Ajax.get(`/fs-user-question-intel-dis`, data);
export const getRandomSmart = data => Ajax.get(`/fs-user-question-random-dis`, data);
export const getTSTopic = data => Ajax.get(`/fs-user-question-intel`, data);
export const getRSTopic = data => Ajax.get(`/fs-user-question-random`, data);

// 消息中心
export const getNotice = data => Ajax.get(`/fs-user-notice`, data);
export const postComplaint = data => Ajax.post(`/fs-user-complaint`, jsToFormData(data));

// 考试中心
export const getXExams = data => Ajax.get(`/fs-exam-apply`, data);
export const getGExams = data => Ajax.get(`/fs-exam-unify`, data);
export const getMyExams = data => Ajax.get(`/fs-exam-signup`, data);
export const getExamsNotice = data => Ajax.post(`/fs-exam-apply-ask`, jsToFormData(data));
export const examSign = data => Ajax.post(`/fs-exam-apply-post`, jsToFormData(data));
export const getPayLists = data => Ajax.get(`/fs-exam-apply-order`, data);
export const wechatPay = data => Ajax.post(`/fs-exam-apply-wechat-payqrcode`, jsToFormData(data, false));
export const payqrcode = data => Ajax.post(`/fs-exam-apply-ali-payqrcode`, jsToFormData(data, false));
export const isPay = data => Ajax.post(`/pay-qrcode-verify`, jsToFormData(data), false);
export const offPay = data => Ajax.post(`/fs-exam-apply-offine-pay`, jsToFormData(data));
export const resetSign = data => Ajax.post(`/fs-exam-apply-reset`, jsToFormData(data));

// 阅卷老师
export const getCheckExams = () => Ajax.get(`/fs-exam-check-exams`, null);
export const getExamFilter = () => Ajax.get(`/fs-making-papers-teacher-header`, null);
export const getCheckExamsAll = data => Ajax.get(`/fs-making-teacher-question`, data);
export const getAllAnswer = data => Ajax.get(`/fs-making-all-answer`, data);
export const postCheckRemark = data => Ajax.post(`/fs-making-papers-teacher-text`, jsToFormData(data), false);
export const autoSave = data => Ajax.post(`/fs-making-set-score`, jsToFormData(data));

// 阅卷督查
export const getLatestExams = () => Ajax.get(`/fs-exam-latel-exams`, null);
export const getAllExams = data => Ajax.get(`/fs-making-all-test`, data);
export const getAllExamsStudent = data => Ajax.get(`/fs-making-student-test`, data);

// 机构、专业、课程
export const getInstitution = data => Ajax.get(`/fs-teacher-making-institution`, data);
export const getProfession = data => Ajax.get(`/fs-teacher-making-profession`, data);
export const getCourse = data => Ajax.get(`/fs-teacher-making-course`, data);
export const getTest = data => Ajax.get(`/fs-teacher-making-test`, data);

// 我的收藏
export const getCollectRecords = () => Ajax.get(`/fs-user-coll-course`, null);
export const getCollectNum = data => Ajax.get(`/fs-user-coll-question`, data);
export const getCollectTopic = data => Ajax.get(`/fs-user-coll-list`, data);

// 我的笔记
export const getNoteRecords = () => Ajax.get(`/fs-user-qnote-course`, null); //我的笔记
export const getNoteCollectNum = data => Ajax.get(`/fs-user-qnote-question`, data);

// 错题集
export const getCollectErr = data => Ajax.get(`/fs-user-error-list`, data);

